import React from 'react';
import katzLogo from '../../images/katz-logo.png';

const ProgramDescription = () => {
  return (
    <section className="section">
      <div className="container">
        <div className="columns is-centered">
          <div className="column is-8">
            <div className="content is-medium">
              <p className="has-text-centered mb-5">
                iCARE is a new, free program for caregivers looking for
                self-paced education and tips about navigating adolescent
                substance use. This program is funded by the Massachusetts
                Department of Public Health and can be completed on a
                computer/tablet or phone by{' '}
                <a href="https://mydrkatz.com/#/signup/csbh">
                  creating a free, individual learner account
                </a>{' '}
                on the Dr. Katz app, a healthcare knowledge platform.
              </p>
              <div className="columns is-centered">
                <div className="column is-half has-text-centered">
                  <img src={katzLogo} alt="katz logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramDescription;
